import { ORDER_REQUEST, ORDER_SUCCESS, ORDER_FAILURE } from '../../actions/types';
import getSafe from '../../utils/getSafe';

const initialState = {
  loading: false,
  error: undefined,
};

export default function ordersReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ORDER_SUCCESS: {
      return {
        ...state,
        loading: false,
        all: getSafe(() => action.payload.orders)
          ? action.payload.orders.map((order) => ({
              id: order.id,
              needsRating: order.needs_rating,
              restaurantName: order.restaurant.name,
              isCollectionOrder: order.status === 'PICKED_UP_BY_CUSTOMER',
            }))
          : undefined,
        error: undefined,
      };
    }
    case ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          status: action.status,
        },
      };
    default:
      return state;
  }
}
